enum PaymentRequestStatus {
  pending = 'pending',
  cancelled = 'cancelled',
  completed = 'completed',
}

export default PaymentRequestStatus
